import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useToast } from '@/view/components/ui/use-toast'
import { selfHireService } from '../services/selfHireService'

export const useSelfHireMaritalStatus = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { isError, isFetching, isLoading, data } = useQuery({
    queryKey: ['self-hire-maritalStatus'],
    queryFn: selfHireService.getMaritalStatus,
    enabled,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar o estado civil, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isFetching,
    isLoading,
    data,
  }
}
